import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import moment from 'moment'

export default function Agenda(props) {

  const [event, setEvent] = useState([])
  const [eventSelected, setEventSelected] = useState({})

  useEffect(() => {

    fetch('https://playattitude.fr/admin/booking/all', {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
        })
    }).then(res => res.json())
        .then(res => {
            let data = res
            data.forEach(element => {
              var date = new Date(element.date)
              element.date = moment(date).format("YYYY-MM-DD HH:mm").replace(' ', 'T')
              let start = date.setHours(element.start.split(':')[0])
              let end = date.setHours(element.end.split(':')[0])
              console.log('cjcjcjcj', start, end)
              console.log('date', moment(start).format("YYYY-MM-DD HH:mm").replace(' ', 'T'), moment(start).format("YYYY-MM-DD HH:mm").replace(' ', 'T'))
              element.start = moment(start).format("YYYY-MM-DD HH:mm").replace(' ', 'T');
              element.end = moment(end).format("YYYY-MM-DD HH:mm").replace(' ', 'T');
              element.title = element.name ? element.name : "Terrain XX"
              if(props.admin)
                element.url = "/match/" + element.booking_id
              if(element.format == "Entrainement") 
                element.color = "red"
            });
            setEvent(data)
            console.log('test', data)
        })
}, [])
var handleEventClick = function({ event, el }) {
  console.log(event, el)
  setEventSelected({ event });
};


  return (
      <FullCalendar
        initialView="timeGridWeek"
        headerToolbar={{
          left: "prev,next",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        buttonText={{
          today: "Aujourd'hui",
          month: "Mois",
          week: "Semaine",
          day: "Jour",
          list: "Liste"
        }}
        plugins={[dayGridPlugin, timeGridPlugin]}
        events={event}
        locale='fr'
        eventClick={(e) => handleEventClick(e)}
      />
  );
}